import { QueryClient } from "@tanstack/react-query";

import { ContactsQuery } from "../../../generated/app-service-gql/graphql";
import { ContactResult } from "./useContacts";

/**
 * Updates the cached contacts data for a specific contact using the provided updater function.
 * @param param0
 */
export function updateCachedContacts({
  queryClient,
  contactId,
  updateContactsRow,
}: {
  queryClient: QueryClient;
  contactId: string;
  updateContactsRow: (r: ContactResult) => ContactResult;
}) {
  queryClient.setQueriesData<ContactsQuery>({ queryKey: ["contacts"], exact: false }, (data) => {
    const results = data?.contacts?.results;
    if (!results || results.length === 0) return data;

    const index = results.findIndex((c) => c.id === contactId);

    if (index === -1) return data;

    const nextRow = updateContactsRow(results[index]);

    // updater must return the same reference object to signal "no change" to the cache
    if (nextRow === results[index]) return data;

    const nextResults = results.slice();
    nextResults[index] = nextRow;

    return {
      ...data,
      contacts: {
        ...data.contacts,
        results: nextResults,
      },
    };
  });
}
